import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StepStyleContainer } from '../@shared/step-style-container';
import { Button } from '@components/Common';
import { useBindingProvider } from 'core/Auth';
import { SteamBinding } from '../../icons';

export const SteamBindingStep = () => {
  const { t } = useTranslation('steam-settings');
  const { handleBindingProvider } = useBindingProvider();

  return (
    <Container>
      <div className="step-header">
        <h5 className="step-header-title">{t('Attach Steam account')}</h5>
        <div className="step-header-warning-message">
          <i className="icon-warn" />
          <p>{t('You need to attach your Steam account to continue')}</p>
        </div>
      </div>
      <Button className="steam-provider" onClick={handleBindingProvider('steam')}>
        <SteamBinding />
        {t('Attach Steam')}
        <i className="icon-redirect-link" />
      </Button>
    </Container>
  );
};

const Container = styled(StepStyleContainer)``;
